'use strict';

const requiresRecursion = (toFreeze, prop) => {
		return (typeof toFreeze[prop] === 'object' || typeof toFreeze[prop] === 'function') && !Object.isFrozen(toFreeze[prop]);
	},
	deepFreeze = function (toFreeze) {
		Object.freeze(toFreeze);

		Object.getOwnPropertyNames(toFreeze).forEach((prop) => {
			if (toFreeze.hasOwnProperty(prop) && toFreeze[prop] !== null && requiresRecursion(toFreeze, prop)) {
				deepFreeze(toFreeze[prop]);
			}
		});

		return toFreeze;
	};
module.exports = deepFreeze;
